var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ais-clear-refinements", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ canRefine, refine, createURL }) {
          return [
            _c(
              "a",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isVisible(canRefine),
                    expression: "isVisible(canRefine)",
                  },
                ],
                staticClass: "clear-filters",
                class: {
                  disabled: _vm.isDisabled(canRefine),
                  "p-0": _vm.withIcon,
                },
                attrs: {
                  disabled: _vm.isDisabled(canRefine),
                  href: createURL(),
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.handleClickRefinement(refine)
                  },
                },
              },
              [
                _vm.withIcon
                  ? [_c("div", { staticClass: "mdi mdi-24px mdi-delete" })]
                  : [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "ui.components.base.ais.clear_refinements.label"
                            )
                          ) +
                          "\n      "
                      ),
                    ],
              ],
              2
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }